import { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';

const navLinks = [
  { label: '事業内容', href: '#business' },
  { label: 'サービス', href: '#services' },
  { label: 'プロデュース', href: '#produce' },
  { label: '民泊申請', href: '#minpaku' },
  { label: '管理業務', href: '#kanri' },
  { label: 'リフォーム', href: '#reform' },
  { label: '貸別荘の運営', href: '#kashisouvilla' },
  { label: 'お問い合わせ', href: '#contact' },
];

export default function Navbar() {
  const [scrolled, setScrolled] = useState(false);
  const [menuOpen, setMenuOpen] = useState(false);

  useEffect(() => {
    const handleScroll = () => setScrolled(window.scrollY > 60);
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  const handleNav = (e: React.MouseEvent<HTMLAnchorElement>, href: string) => {
    e.preventDefault();
    setMenuOpen(false);
    const el = document.querySelector(href);
    if (el) el.scrollIntoView({ behavior: 'smooth' });
  };

  return (
    <header
      className={`fixed top-0 left-0 w-full z-50 transition-all duration-500 ${
        scrolled ? 'bg-white/95 backdrop-blur-sm border-b border-stone-200' : 'bg-transparent'
      }`}
    >
      <div className="max-w-7xl mx-auto px-6 lg:px-12 flex items-center justify-between h-16 lg:h-20">
        {/* Logo */}
        <a href="#" onClick={(e) => handleNav(e, '#')}>
          <img
            src="https://static.readdy.ai/image/13912524abd39dd1dc7f5a01ff0217d1/7addc6331c966f3e395b0cb5315fdc96.jpeg"
            alt="株式会社グランドビレッジ"
            className="h-10 lg:h-12 w-auto object-contain"
          />
        </a>

        {/* Desktop Nav */}
        <nav className="hidden lg:flex items-center gap-6 xl:gap-8">
          {navLinks.map((link) =>
            link.label === 'お問い合わせ' ? (
              <a
                key={link.href}
                href={link.href}
                onClick={(e) => handleNav(e, link.href)}
                className={`whitespace-nowrap text-sm font-medium px-5 py-2 rounded-full border transition-all duration-300 cursor-pointer ${
                  scrolled
                    ? 'border-stone-800 text-stone-800 hover:bg-stone-800 hover:text-white'
                    : 'border-white text-white hover:bg-white hover:text-stone-800'
                }`}
              >
                {link.label}
              </a>
            ) : (
              <a
                key={link.href}
                href={link.href}
                onClick={(e) => handleNav(e, link.href)}
                className={`whitespace-nowrap text-sm font-medium transition-colors duration-300 cursor-pointer hover:opacity-70 ${
                  scrolled ? 'text-stone-700' : 'text-white/90'
                }`}
              >
                {link.label}
              </a>
            )
          )}
          <Link
            to="/company"
            className={`whitespace-nowrap text-sm font-medium transition-colors duration-300 cursor-pointer hover:opacity-70 ${
              scrolled ? 'text-stone-700' : 'text-white/90'
            }`}
          >
            会社概要
          </Link>
        </nav>

        {/* Mobile Menu Button */}
        <button
          className={`lg:hidden w-8 h-8 flex items-center justify-center cursor-pointer ${scrolled ? 'text-stone-800' : 'text-white'}`}
          onClick={() => setMenuOpen(!menuOpen)}
          aria-label="メニュー"
        >
          <i className={`text-xl ${menuOpen ? 'ri-close-line' : 'ri-menu-3-line'}`} />
        </button>
      </div>

      {/* Mobile Menu */}
      {menuOpen && (
        <div className="lg:hidden bg-white border-t border-stone-200">
          {navLinks.map((link) => (
            <a
              key={link.href}
              href={link.href}
              onClick={(e) => handleNav(e, link.href)}
              className="block px-6 py-4 text-sm text-stone-700 border-b border-stone-100 hover:bg-stone-50 cursor-pointer"
            >
              {link.label}
            </a>
          ))}
          <Link
            to="/company"
            className="block px-6 py-4 text-sm text-stone-700 border-b border-stone-100 hover:bg-stone-50 cursor-pointer"
            onClick={() => setMenuOpen(false)}
          >
            会社概要
          </Link>
        </div>
      )}
    </header>
  );
}
